module.exports = __webpack_public_path__ + "img/vote-btn_txt_pre.f1b9f4e5.png";